import { GameConstants } from "./GameConstants";
import { AudioManager } from "./AudioManager";
import { GameVars } from "./GameVars";

export class GameManager {

    private static game: Phaser.Game;

    public static init(game: Phaser.Game): void {

        GameManager.game = game;

        GameVars.minesweeper = require("minesweeper");

        if (GameVars.areValidDomains(["unblocked-games", "onlinegames", "totallyscience", "freezenova.com", "localhost", "127"])) {
            GameManager.readGameData();
        } 
    }

    public static readGameData(): void {

        GameManager.getGameStorageData(
            GameConstants.SAVED_GAME_DATA_KEY,
            function (gameData: string): void {

                if (gameData) {
                    GameVars.gameData = JSON.parse(gameData);
                } else {
                    GameVars.gameData = {
                        muted: false,
                        highscores: {
                            [GameConstants.DIFFICULTY_EASY]: { score: 10e5 },
                            [GameConstants.DIFFICULTY_MEDIUM]: { score: 10e5 },
                            [GameConstants.DIFFICULTY_HARD]: { score: 10e5 }
                        },
                        victories: {
                            easy: 0,
                            medium: 0,
                            hard:0
                        }
                    };
                }

                GameManager.writeGameData();
                GameManager.startGame();
            },
            function (error: Error): void {
                GameManager.log("error retriving saved game data.", error);
            }
        );
    }

    public static onGameAssetsLoaded(): void {

        AudioManager.init(GameManager.game);

        GameManager.enterSplashState();
    }

    public static enterSplashState(): void {

        if (GameManager.game) {
            GameManager.game.state.start("SplashState", true, false);
        }
    }

    public static enterBoardScene(difficulty: string): void {

        GameVars.difficulty = difficulty;

        GameManager.game.state.start("BoardState", true, false);
    }

    public static enterTutorialScene(): void {

        GameManager.game.state.start("TutorialState", true, false);
    }

    public static reset(): void {

        GameManager.enterBoardScene(GameVars.difficulty);
    }

    public static matchOver(): void {

        if (GameVars.gameData.highscores[GameVars.difficulty].score > GameVars.time) {
            GameVars.gameData.highscores[GameVars.difficulty].score = GameVars.time;
            
        }

        GameManager.writeGameData();
    }

    public static writeGameData(): void {

        GameManager.setGameStorageData(
            GameConstants.SAVED_GAME_DATA_KEY,
            GameVars.gameData,
            function (): void {
                GameManager.log("game data successfully saved");
            },
            function (error: Error): void {
                GameManager.log("error saving game data", error);
            }
        );
    }

    public static log(text: string, error?: Error): void {

        if (!GameConstants.VERBOSE) {
            return;
        }

        if (error) {
            console.error(text + ":", error);
        } else {
            console.log(text);
        }
    }

    private static startGame(): void {

        GameManager.game.state.start("PreLoader", true, false);
    }

    private static getGameStorageData(key: string, successCb: Function, failureCb: Function): void {

        const gameDataStr = localStorage.getItem(key);
        successCb(gameDataStr);
    }

    private static setGameStorageData(key: string, value: any, successCb: Function, failureCb: Function): void {

        localStorage.setItem(key, JSON.stringify(value));
        successCb();
    }
}
